import axios from 'axios';
import user from '../utils/user';

export default {
  async getOriginalValueBillet(id) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/billets/${id}/original-value`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getInterestFineValueBillet(id, newDueDate) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/billets/${id}/interest-fine-value`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
          params: { new_due_date: newDueDate },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async downBillet(id, payload) {
    try {
      const response = await axios.patch(
        `${process.env.VUE_APP_API_VIDA_URL}/billets/${id}/payment`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async updateBillet(id, payload) {
    try {
      const response = await axios.patch(
        `${process.env.VUE_APP_API_VIDA_URL}/billets/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getBilletSituations() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/billets/situations`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
